// apps/web/src/services/AuthService.js

import fetch from 'auth/FetchInterceptor'
import { AUTH_TOKEN } from 'constants/AuthConstant'

const AuthService = {}

const saveAuthData = (result) => {
  const token = result?.token || result?.accessToken

  if (token) {
    localStorage.setItem(AUTH_TOKEN, token)
    localStorage.setItem('AUTH_TOKEN', token)
    localStorage.setItem('ACCESS_TOKEN', token)
  }

  if (result?.user) {
    localStorage.setItem('AUTH_USER', JSON.stringify(result.user))
    localStorage.setItem('USER_ROLE', result.user.role || '')
  }

  localStorage.setItem('CLIENT_ID', result?.clientId || '')
  localStorage.setItem('CLIENTS', JSON.stringify(result?.clients || []))
}

AuthService.login = async function (data) {
  const result = await fetch({
    url: '/auth/login',
    method: 'post',
    data,
  })

  console.log('LOGIN RESPONSE:', result)

  saveAuthData(result)

  return result
}

AuthService.register = async function (data) {
  const result = await fetch({
    url: '/auth/register',
    method: 'post',
    data,
  })

  saveAuthData(result)

  return result
}

AuthService.logout = async function () {
  const result = await fetch({
    url: '/auth/logout',
    method: 'post',
  })

  localStorage.removeItem(AUTH_TOKEN)
  localStorage.removeItem('AUTH_TOKEN')
  localStorage.removeItem('ACCESS_TOKEN')
  localStorage.removeItem('AUTH_USER')
  localStorage.removeItem('USER_ROLE')
  localStorage.removeItem('CLIENT_ID')
  localStorage.removeItem('CLIENTS')

  return result
}

AuthService.loginInOAuth = function () {
  return fetch({
    url: '/auth/loginInOAuth',
    method: 'post',
  })
}

export default AuthService